import React from 'react'
import Header from '@components/Layout/Header'
import Sidebar from '@components/Layout/Sidebar'
import Content from '@components/Layout/Content'
import ErrorAlert, { ErrorAlertProps } from '@components/ErrorAlert'
import { Typography } from '@mui/material'

type ErrorPageProps = {
  error: ErrorAlertProps['error'];
}

const ErrorPage = ({ error }: ErrorPageProps) => {
  return (
    <>
      <Header />
      <Sidebar />
      <Content>
        <Typography variant='h4' color='error' fontSize={21} sx={{ mb: 2 }}>
          Упс... что-то пошло не так. Попробуйте перезагрузить страницу.
        </Typography>
        <ErrorAlert error={error} />
      </Content>
    </>
  )
}

export default ErrorPage